(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.directive('lateDeliveryCausesChartWidget', lateDeliveryCausesChartWidget);

	function lateDeliveryCausesChartWidget($compile, $filter, $window, $timeout, $experiments, drilldownFunctionsService,
			$rootScope, $state, $translate, integerFormatService, fullPageChart) {
		return {
			restrict: 'A',
			scope: {
				isEmbedded: '@isEmbedded'
			},
			link: function linkFullPageChart(scope, element, attr) {
				var embedded = scope.isEmbedded || false;
				var chart;
				var initListener;
				var w = angular.element($window);
				var windowHeight = embedded ? 250 : 0;
				var slideshow = false;
				var scopeAccessor = scope.$parent;
				var categoryMap = {}, categoryTimeOut;
				if (jQuery(element[0]).parents('.slideshowWidget').length) {
					slideshow = true;
				}
				w.bind('resize', function () {
					windowHeight = embedded ? 250 : fullPageChart.resizeChart('lateDeliveryCausesChartCont');
					if (chart) {
						chart.resize({
							height: windowHeight
						});
					}
				});

				function init() {
					var hbCont = jQuery('#handlebarContainer').length;
					var supplierPortal = globalConfig.user.role === 'Supplier';
					var gridLoaded = jQuery('#lateDeliveryCausesChartCont').length;
					if (globalConfig && globalConfig.factory && gridLoaded) {
						jQuery('#handlebarContainer').bind('leftNavChanged', function () {
							windowHeight = fullPageChart.resizeChart(scopeAccessor.navProps.hideSubNav, 'lateDeliveryCausesChartCont');
							generateChart();
						});
						if (!embedded) {
							windowHeight = fullPageChart.resizeChart('lateDeliveryCausesChartCont');
						}

						generateChart();
					} else {
						$timeout(function () {
							init();
						}, 10);
					}
				}

				var getStackSum = function (d) {
					var sum = 0;
					for (var prop in d) {
						if (d.hasOwnProperty(prop) && !isNaN(d[prop])) {
							sum += d[prop];
						}
					}
					return sum;
				};

				function addCategoriesTitle(elemId, groups) {
					var categoriesContainer = d3.selectAll(elemId + ' .c3-axis.c3-axis-x .tick')._groups[0];
					for (var i = 0; i < categoriesContainer.length; i++) {
						var categoryText = d3.select(categoriesContainer[i]).text();
						d3.select(categoriesContainer[i]).append('title').text(categoryMap[categoryText]);
					}
				}

				function restrictXAxisLabels(limit, chartCategories) {
					// abbreviate the vertical axis labels to fit
					var categories = [];
					var limitLabelWidth = limit;
					var tempSvg = d3.select('body').append('svg');
					var tempTextElement = tempSvg.append('text');
					angular.forEach(chartCategories, function (category) {
						var tempCategory = category;
						tempTextElement.text(tempCategory);
						var trimAmount = 0;
						var textSize = tempTextElement.node().getBBox();
						// font isn't monospace, so have to draw and measure the text to trim to a given width
						while (textSize.width > limitLabelWidth) {
							trimAmount += 1;
							tempCategory = category.substring(0, category.length - trimAmount) + '..';
							tempTextElement.text(tempCategory);
							textSize = tempTextElement.node().getBBox();
						}
						categoryMap[tempCategory] = category;
						categories.push(tempCategory);
					});
					tempTextElement.remove();
					tempSvg.remove();
					return categories;
				}

				function tooltipFormat(d, defaultTitleFormat, defaultValueFormat, color) {
					var $$ = this,
						config = $$.config,
						CLASS = $$.CLASS,
						titleFormat = config.tooltip_format_title || defaultTitleFormat,
						nameFormat = config.tooltip_format_name || function (name) {
							return name;
						},
						valueFormat = config.tooltip_format_value || defaultValueFormat,
						text, i, title, value, name, bgcolor;

					for (i = 0; i < d.length; i++) {
						if (!(d[i] && (d[i].value || d[i].value === 0))) {
							continue;
						}
						if (!text) {
							title = titleFormat ? titleFormat(d[i].x) : d[i].x;
							text = '<table class="' + CLASS.tooltip + '">' +
								(title || title === 0 ?
									'<tr><th colspan="2">' + categoryMap[title] + '</th></tr>' :
									'');
						}
						value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
						if (value !== undefined) {
							text += '<tr class="' + CLASS.tooltipName + '-' + d[i].id + '">';
							text += '<td class="name"><span style="background-color:' + color(d[i]) + '"></span>' +
								$translate.instant(d[i].name) + '</td>';
							text += '<td class="value">' + value + '</td>';
							text += '</tr>';
						}
					}
					return text + '</table>';
				}

				function generateChart() {
					scopeAccessor = scope.$parent;

					if (!scopeAccessor.chartData) {
						return;
					}
					var data = scopeAccessor.chartData;
					var groups = scopeAccessor.chartGroups;
					var chartCategories = scopeAccessor.chartCategories;
					var chartCategoriesToId = scopeAccessor.categoriesToId;
					var limit = 150;
					var categories = restrictXAxisLabels(limit, chartCategories);
					var config = {};
					config.bindto = '#' + element[0].id;
					config.data = {};
					config.data.keys = {
						value: groups
					};
					config.data.json = data;
					config.data.type = 'bar';
					config.data.order = null;
					config.data.names =  {
						'lateCustomerPos': $translate.instant('Late') + ' - ' + globalConfig.customer.name,
						'lateVendorPos': $translate.instant('Late') + ' - ' +  $translate.instant('Vendor'),
						'earlyCustomerPos': $translate.instant('Early') + ' - ' + globalConfig.customer.name,
						'earlyVendorPos': $translate.instant('Early') + ' - ' +  $translate.instant('Vendor')
					};
					config.data.colors = {
						'lateCustomerPos': '#0A264B', //galaxy-shade
						'lateVendorPos': '#F1AB23', //rocket-shade
						'earlyCustomerPos': '#0E509A', //galaxy-tint
						'earlyVendorPos': '#FBD551' //rocket-tint
					};
					config.data.labels = false;
					config.data.groups = [groups];
					config.padding = {
						top: 5,
						left: embedded ? 100 : 50,
						right: 30
					};
					config.axis = {};
					config.axis.x = {
						type: 'category',
						categories: categories,
						tick: {}
					};
					if (!embedded) {
						config.axis.x.tick.rotate = -60;
						config.axis.x.height = 200;
					} else {
						config.axis.x.tick.width = 80;
						config.axis.x.tick.multiline = true;
						config.axis.x.tick.multilineMax =  2;
					}

					var yAxisMin = d3.min([0, d3.min(data, getStackSum)]);
					var yAxisMax = d3.max(data, getStackSum);
					if (yAxisMax < 5) {
						yAxisMax = 5;
					}
					config.axis.y = {
						tick: {
							format: function (x) {
								return integerFormatService.get(x);
							},
							count: 4
						},
						padding: {
							bottom: 0
						},
						min: yAxisMin,
						max: yAxisMax
					};

					if (!embedded) {
						config.data.onclick = function (d) {
							var poReportUrl = '/application/f/home.html#/supply-chain/purchase-orders/?drilldown=1&';
							var reactFilters = [];
							var filters = scopeAccessor.leanFilterService;
							var timePeriodParams = scopeAccessor.leanFilterService.getTimePeriodFilterQueryParam('timePeriod', scopeAccessor.filterService.getSelected('Time Period'), true);
							var timePeriod = timePeriodParams['timePeriod'];
							var queryParams = filters.getQueryParamsObject(true, true);
							var factories = scopeAccessor.leanFilterService.getFactoryList();
							if (globalConfig.factory.id.toString() !== factories) {
								queryParams['factory'] = scopeAccessor.leanFilterService.getFactoryList();
							}

							if (timePeriod) {
								var startDate, endDate;
								if (scopeAccessor.timeStampsByTimePeriod && scopeAccessor.timeStampsByTimePeriod[timePeriod]) {
									startDate = scopeAccessor.timeStampsByTimePeriod[timePeriod]['start'];
									endDate = scopeAccessor.timeStampsByTimePeriod[timePeriod]['end'];
								} else if (timePeriod === 'custom') {
									var timePeriodValueOne = moment.utc(timePeriodParams['timePeriodValueOne']).startOf('month').format('YYYY-MM-DD');
									var timePeriodValueTwo = moment.utc(timePeriodParams['timePeriodValueTwo']).endOf('month').format('YYYY-MM-DD');
									startDate = moment.utc(timePeriodValueOne).unix() * 1000;
									endDate = moment.utc(timePeriodValueTwo).unix() * 1000;
								} else if (!isNaN(timePeriod)) {
									var currentDate = moment.utc(new Date());
									startDate = currentDate.subtract(parseInt(timePeriod), 'd').format('YYYY-MM-DD');
									endDate = moment.utc(new Date()).format('YYYY-MM-DD');
									startDate = moment.utc(startDate).unix() * 1000;
									endDate = moment.utc(endDate).unix() * 1000;
								}
								queryParams['goldenSupplyDateValueOne'] = startDate;
								queryParams['goldenSupplyDateValueTwo'] = endDate;
								queryParams['goldenSupplyDateComparator'] = 'btw';
								var requestedFilter = { id: 'goldenSupplyDate', comparator: 'Between', valueOne: startDate, valueTwo: endDate };
								reactFilters.push(requestedFilter);
							}
							queryParams = _.omit(queryParams, ['lateDeliveryDescription', 'lateDeliveryLiability', 'timePeriod', 'timePeriodValueOne', 'timePeriodValueTwo']);
							queryParams['lateDeliveryDescription'] = scopeAccessor.chartCategories[d.index];
							queryParams['lateDeliveryLiability'] = scopeAccessor.chartData[d.index].liability || 'Vendor';
							var url;
							Object.keys(queryParams).forEach(function (key) {
								if (key !== 'factory' && !key.includes('request')) {
									reactFilters.push({ id: key, values: [queryParams[key]] });
								}
							});
							url = 'home.html#/supply-chain/purchase-orders/' + drilldownFunctionsService.makeDrilldownParamString(reactFilters, true, []);
						
							window.open(url, '_blank');
						};
					}

					config.tooltip = {
						contents: tooltipFormat
					};

					config.axis.rotated = embedded;
					config.size = {};
					config.size.height = windowHeight;
					config.legend = {
						show: true,
						item: {
							onclick: function(d) {
								chart.toggle(d);
							}
						}
					};
					config.grid = {
						x: {
							show: false
						},
						y: {
							show: true
						}
					};
					chart = c3.generate(config);

					categoryTimeOut = setTimeout(function () {
						addCategoriesTitle(config.bindto, scopeAccessor.chartGroups);
					}, 1000);
				}

				initListener = scope.$on('lateDeliveryCausesChartReady', function () {
					init();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (initListener) {
						initListener();
					}
					clearTimeout(categoryTimeOut);
					w.unbind('resize');
				});

			}
		};
	}
})();
